'use client';

import React, { useEffect, useRef } from 'react';
import dynamic from 'next/dynamic';

const SearchBox = dynamic(() => import('@/components/search/SearchBox'));
const SearchResults = dynamic(() => import('@/components/search/SearchResults'));

export default function SearchPageContent() {
  const searchBoxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Focus the search input when the component mounts
    const searchInput = searchBoxRef.current?.querySelector('input');
    if (searchInput) {
      searchInput.focus();
    }
  }, []);

  return (
    <div ref={searchBoxRef}>
      <SearchBox />
      <SearchResults />
    </div>
  );
}
